import React, { Fragment } from 'react';
import CloseIcon from '../../../../icons/CloseIcon';
import ErrorMessage from '../../ErrorMessage';

/**
 * Action was a request for an idempotent*) state-change. It is UNKNOWN whether
 * it succeeded, but the user is safe to retry.
 *
 * *) Idempotent action is one where it IS KNOWN that the request for it can be
 * *repeated automatically* when the success response was not received
 * (as per [rfc7231#section-4.2.2](https://tools.ietf.org/html/rfc7231#section-4.2.2), as well as [HTTP 1.1](https://tools.ietf.org/html/rfc2616#section-9.1.2))
 */
const WriteUnknownResultErrorSafeToRetryMessage = ({
    resultDescription,
    resolutionToTryBeforeContacting,
    onDismiss,
}) => (
    <ErrorMessage>
        <div style={{ display: 'flex' }}>
            <span style={{ width: '100%' }}>
                <section>
                    <h1>An error occurred</h1>
                    <span>
                        {resultDescription || (
                            <Fragment>
                                Your recent change encountered an error. It
                                might have not been fulfilled.
                            </Fragment>
                        )}
                    </span>
                    <span className="resolution">
                        {' '}
                        {resolutionToTryBeforeContacting || (
                            <Fragment>
                                Please check your connection and try again. Also
                                try refreshing the page.
                            </Fragment>
                        )}{' '}
                        Contact support if the problem persists.
                    </span>
                </section>
            </span>
            <CloseIcon
                onClick={onDismiss}
                style={{ cursor: 'default', marginRight: '1em' }}
            />
        </div>
    </ErrorMessage>
);

export default WriteUnknownResultErrorSafeToRetryMessage;
